<script>
import Layout from '@layouts/main'

import Datatable from '@components/Datatable';

import {AxiosHelper} from '@src/utils/utils';
import { getAudioDB } from '@utils/lidb';

import RecentUpdatePopup from './recent_update_popup';
import FileMatchPopup from './file_match_popup';
import MixMatchPopup from './mix_match_popup';
import EtcMusicRegistPopup from './etc_music_regist_popup';

export default {
	components: { Layout, Datatable, RecentUpdatePopup, FileMatchPopup, MixMatchPopup, EtcMusicRegistPopup },
  data() {
    return {
			fileExist : 'ALL',
			range : 'ALL',
			orderCond : 'regdate',
			keyword : '',
			tableData : [],
			searched : 'ALL',

			db : getAudioDB(),

			tableOption : {
				scrollY: 440,
				// autoWidth: false,
				columns : [
					{data : 'media'},
					{data : 'norae_no'},
					{data : 'title'},
					{data : 'artist'},
					{data : 'regdate'},
					{data : 'fileregdate'},
					{data : 'hasFile'},
				],
				paging : false,
				columnDefs : [
					{
						width : '35px',
						targets : 0
					},
					{
						width : '50px',
						targets : 1
					},
					{
						width : '290px',
						targets : 2
					},
					{
						width : '170px',
						targets : 3
					},
					{
						width : '60px',
						targets : 4
					},
					{
						width : '60px',
						targets : 5
					},

					{
						render : function(data, type, row) {
							if(data === 'Y')
								return `<div class="">
													<button type="button" data-type="play" class="btn btn-blue btn-xs waves-effect waves-light">재생</button>
													<button type="button" data-type="add" class="btn btn-danger btn-xs waves-effect waves-light">재생추가</button>
													<button type="button" data-type="removeFile" class="btn btn-danger btn-xs waves-effect waves-light">파일삭제</button>
												</div>`;
							return '';
						},
						width : '200px',
						targets : 6
					},
					{
						render : function(data, type, row) {
							return '<button type="button" data-type="remove" class="btn btn-danger btn-xs waves-effect waves-light">내역삭제</button>';
						},
						width : '80px',
						targets : 7
					},
				]
			},


    }
	},
	created() {
		this.recentList();
	},
	mounted() {
	},
	methods : {
		recentList() {
			AxiosHelper.get(`/api/music/recent`, {
				params : {
					fileExist : this.fileExist,
					range : this.range,
					orderCond : this.orderCond,
					keyword : this.keyword
				}
			}).then(ret => {
				this.tableData = ret.data;
				this.searched = this.fileExist;
			})
		},
	
		searchData(e) {
			AxiosHelper.get(`/api/music/search`, {
				params : {
					fileExist : this.fileExist,
					range : this.range,
					orderCond : this.orderCond,
					keyword : this.keyword
				}
			}).then(ret => {
				this.tableData = ret.data;
				this.searched = this.fileExist
			});
		},

		showFileMatch() {
			this.$refs.fileMatchPopup.show();
		},

		showMixMatch() {
			this.$refs.mixMatchPopup.show();
		},

		showRecentUpdate() {
			this.$refs.recentUpdatePopup.show();
		},

		showEtcMusicRegist() {
			this.$refs.etcMusicRegistPopup.show();
		},

		allPlayAdd() {
			this.pushMessage("재생목록 추가 시작");
			const base = new Date().getTime();
			this.tableData.forEach((item, idx) => {
				this.db.insert({
					artist : item.artist,
					title : item.title,
					mp3 : '/api/music/' + item.media + '/' + item.norae_no,
					time : base + idx 
				});
			});
			this.pushMessage("추가 완료");
		},

		tableClick(index, data, event) {
			event.preventDefault();
			event.stopPropagation();

			if(event.currentTarget.dataset.type === 'play') {	// 재생
			}
			else if(event.currentTarget.dataset.type === 'add') {	// 재생추가
				this.db.insert({
					artist : data.artist,
					title : data.title,
					mp3 : '/api/music/' + data.media + '/' + data.norae_no,
					time : new Date().getTime()
				});
			}
			else if(event.currentTarget.dataset.type === 'removeFile') {	// 파일삭제
				if(!window.confirm('정말로 삭제할까요?')) {
					return;
				}
				
				this.pushMessage('삭제시작');
				AxiosHelper.get(`/api/music/${data.media}/${data.norae_no}/fileDelete`).then(ret => {
					this.pushMessage('삭제완료');
				});
			}
			else if(event.currentTarget.dataset.type === 'remove') {	// 내역삭제
				if(!window.confirm('정말로 삭제할까요?')) {
					return;
				}
				
				this.pushMessage('삭제시작');
				AxiosHelper.get(`/api/music/${data.media}/${data.norae_no}/delete`).then(ret => {
					this.pushMessage('삭제완료');
				});
			}
		},



	}
}
</script>

<template>
  <Layout>
		<C.PageHeader title="음악 관리"/>

		<C.Row>
			<C.Col lg="12">
				<C.Card>
					<C.CardBody>
						<C.Row class="mb-2">
							<C.Col>
								<div class="form-row align-items-center">
									<div class="col-auto">
										<div class="button-list">
											<button type="button" class="btn btn-blue waves-effect waves-light btn-sm" @click="showRecentUpdate">최근정보 업데이트</button>
											<button type="button" class="btn btn-blue waves-effect waves-light btn-sm" @click="showFileMatch">파일매칭</button>
											<button type="button" class="btn btn-blue waves-effect waves-light btn-sm" @click="showMixMatch">믹스매칭</button>
											<button type="button" class="btn btn-info waves-effect waves-light btn-sm" @click="showEtcMusicRegist">기타노래추가</button>
										</div>
									</div>
								</div>
							</C.Col>
						</C.Row>
						<C.Row class="mb-2">
							<C.Col>
								<div class="form-row align-items-center">
									<div class="col-auto">
										<select v-model="fileExist" class="form-control">
											<option value='ALL'>모두</option>
											<option value='Y'>파일있음</option>
											<option value='N'>파일없음</option>
										</select>
									</div>
									<div class="col-auto">
										<select v-model="range" class="form-control">
											<option value='ALL'>제목+가수</option>
											<option value='TITLE'>제목</option>
											<option value='ARTIST'>가수</option>
										</select>
									</div>
									<div class="col-auto">
										<select v-model="orderCond" class="form-control">
											<option value='regdate'>등록일자순</option>
											<option value='fileregdate'>파일등록순</option>
										</select>
									</div>

									<div class="col-auto">
										<input v-model="keyword" type="text" class="form-control" @keyup.enter="searchData"/>
									</div>
									<div class="col-auto">
										<div class="button-list">
											<button type="button" class="btn btn-info waves-effect waves-light" @click="searchData">검색</button>
											<button type="button" class="btn btn-info waves-effect waves-light" @click="recentList">최신리스트</button>
											<button v-show="searched === 'Y'" type="button" class="btn btn-info waves-effect waves-light" @click="allPlayAdd">재생목록 전체추가</button>
											
										</div>
									</div>
								</div>
							</C.Col>
						</C.Row>

						<Datatable
							:option="tableOption" 
							:data="tableData"
							table-add-classes='table-xs fixed'
							table-remove-classes='table-sm'
							@clickHandler="tableClick"
						>
							<template v-slot:thead>
								<tr>
									<th>종류</th>
									<th>곡번호</th>
									<th>제목</th>
									<th>가수</th>
									<th>등록일</th>
									<th>파일등록일</th>
									<th>재생가능</th>
									<th>기타</th>
								</tr>
							</template>
						</Datatable>

					</C.CardBody>
				</C.Card>
			</C.Col>
		</C.Row>
		<RecentUpdatePopup ref="recentUpdatePopup" />
		<FileMatchPopup ref="fileMatchPopup" />
		<MixMatchPopup ref="mixMatchPopup" />
		<EtcMusicRegistPopup ref="etcMusicRegistPopup" />
  </Layout>
</template>